import SbsLogin from '@sbs/sbs-login';

let sbsLoginSingleton: SbsLogin | undefined;

const getSbsLoginInstance = (): SbsLogin => {
  if (!sbsLoginSingleton) {
    sbsLoginSingleton = new SbsLogin({
      apiHost: process.env.NEXT_PUBLIC_SBS_LOGIN_API_HOST,
      authApiHost: process.env.NEXT_PUBLIC_SBS_LOGIN_AUTH_API_HOST,
      showLanguageSwitcher: false,
      context: 'odwebsite',
      language: 'en',
      loadFonts: false,
      htmlEl: '#sbs-login',
    });
  }

  return sbsLoginSingleton;
};

export default getSbsLoginInstance;
